/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseDescriptionBlockFragment, DescriptionBlockFragment, FullDescriptionBlockFragment} from '@amblique/contentful/app/contentful/fragments/description-block';

/**
 * Get a single DescriptionBlock by ID (base - scalars only)
 */
export const getBaseDescriptionBlockById = gql`
  ${BaseDescriptionBlockFragment}

  query GetBaseDescriptionBlockById($id: String!, $locale: String!, $preview: Boolean) {
    descriptionBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseDescriptionBlockFragment
    }
  }
`;

/**
 * Get a single DescriptionBlock by ID (standard - 1 level deep)
 */
export const getDescriptionBlockById = gql`
  ${DescriptionBlockFragment}

  query GetDescriptionBlockById($id: String!, $locale: String!, $preview: Boolean) {
    descriptionBlock(id: $id, locale: $locale, preview: $preview) {
      ...DescriptionBlockFragment
    }
  }
`;

/**
 * Get a single DescriptionBlock by ID (full - 2 levels deep)
 */
export const getFullDescriptionBlockById = gql`
  ${FullDescriptionBlockFragment}

  query GetFullDescriptionBlockById($id: String!, $locale: String!, $preview: Boolean) {
    descriptionBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullDescriptionBlockFragment
    }
  }
`;

/**
 * Get all DescriptionBlock entries with pagination (base - scalars only)
 */
export const getBaseDescriptionBlocks = gql`
  ${BaseDescriptionBlockFragment}

  query GetBaseDescriptionBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [DescriptionBlockOrder]
    $where: DescriptionBlockFilter
    $preview: Boolean
  ) {
    descriptionBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseDescriptionBlockFragment
      }
    }
  }
`;

/**
 * Get all DescriptionBlock entries with pagination (standard - 1 level deep)
 */
export const getDescriptionBlocks = gql`
  ${DescriptionBlockFragment}

  query GetDescriptionBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [DescriptionBlockOrder]
    $where: DescriptionBlockFilter
    $preview: Boolean
  ) {
    descriptionBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...DescriptionBlockFragment
      }
    }
  }
`;

/**
 * Get all DescriptionBlock entries with pagination (full - 2 levels deep)
 */
export const getFullDescriptionBlocks = gql`
  ${FullDescriptionBlockFragment}

  query GetFullDescriptionBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [DescriptionBlockOrder]
    $where: DescriptionBlockFilter
    $preview: Boolean
  ) {
    descriptionBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullDescriptionBlockFragment
      }
    }
  }
`;
